import React  from "react";
import { useEffect, useState } from 'react';
import {Button,Card,Form,Container,Row,Col} from "react-bootstrap";
import { useParams } from 'react-router-dom';
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import {useActividadesFecha} from '../hooks/useActividadesFecha';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from 'moment';
import 'moment/locale/es';


function EditarActividadFecha(){
  const parametros = useParams();
  console.log(parametros.actividadFechaId)
  const { actividadFechaPorActualizar,setActividadFechaPorActualizar,updateActividadFecha,
    updateRespuestaActualizarActividadFecha,respuestaActualizarActividadFecha,
    getActividadFecha} = useActividadesFecha(parametros.actividadId,parametros.actividadFechaId);
  const [isChangedElements,setChange]=useState(false);
  
  
const actualizarActividadFecha = async() => {
  setChange(false);

  const resp=await updateActividadFecha(actividadFechaPorActualizar);
  
  setChange(true);
};
/*
useEffect( async() => {
  await getActividadFecha();
}, []);
useEffect( async() => {
  //await getActividadFecha();
  updateRespuestaActualizarActividadFecha();  
}, [isChangedElements]);*/

useEffect( () => {
  async function editarActividadFechaFuncion() {
    await getActividadFecha();
  }
  editarActividadFechaFuncion();

}, []);
useEffect( () => {
  
  async function editarActividadFechaFuncion() {
    updateRespuestaActualizarActividadFecha();  
  }
  editarActividadFechaFuncion();
}, [isChangedElements]);




  return (
    <>
      <Container fluid>
      <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Editar Actividad Fecha</Card.Title>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col xs="6">
                  <label>Nombre</label>
                  <Form.Control
                    value={actividadFechaPorActualizar?.ActividadNombre}
                    placeholder=""
                    disabled={true}
                    type="text">
                  </Form.Control>
                  </Col>
                  <Col xs="6">
                  
                  </Col>
                </Row>
                <Row>
                  <Col xs="6">
                  <label>Fecha Inicio</label>
                  <Datetime
                           
                    value={moment(actividadFechaPorActualizar?.Fecha)}
                    onChange={(date) => {
                    const d = moment(date);
                    setActividadFechaPorActualizar({...actividadFechaPorActualizar,['Fecha']:d});
                    }}
                            
                        ></Datetime>
                  </Col>
                  <Col xs="6">
                  <label>Fecha Término</label>
                  <Datetime       
                    value={moment(actividadFechaPorActualizar?.FechaTermino)}
                    onChange={(date) => {
                      const d = moment(date);
                              setActividadFechaPorActualizar({...actividadFechaPorActualizar,['FechaTermino']:d});
                    }}
                    ></Datetime>
                  </Col>
                </Row>

                <Row>
                  <Col xs="6">
                  <label>Asunto</label>
                  <Form.Control
                    value={actividadFechaPorActualizar?.Asunto}
                    onChange={(e,prop) => { 
                      setActividadFechaPorActualizar({...actividadFechaPorActualizar,['Asunto']:e.target.value});
                    }}
                    placeholder=""
                    type="text">
                  </Form.Control>
                  </Col>
                  <Col xs="6">
                  <label>Detalle</label>
                  <Form.Control
                    value={actividadFechaPorActualizar?.Detalle}
                    placeholder=""
                    type="textarea"
                    as="textarea"
                    rows={6}
                    onChange={(e,prop) => { 
                      setActividadFechaPorActualizar({...actividadFechaPorActualizar,['Detalle']:e.target.value});
                    }}
                    >
                  </Form.Control>
                  </Col>
                </Row>

                <Row>
                  <Col xs="12">
                    <label>Asistencia</label>
                    {
                          actividadFechaPorActualizar?.Asistencia?.map((elem,i)=>{
                            const nombre=elem.Nombre;
                            console.log(elem);
                            console.log(i)
                            return (
                              <Form.Check>
                                <Form.Check.Label>
                                <Form.Check.Input
                                  name={elem.ConsultanteId}
                                  checked={!!elem?.Presente}
                                  type="checkbox"
                                  data-afid={elem.ActividadFechaId}
                                  onChange={(e,prop) => {
                                    let asistencias=actividadFechaPorActualizar.Asistencia;
                                    let asistencia=asistencias.find((ev) => ev.ConsultanteId==elem.ConsultanteId);
                                    if(asistencia.Presente){
                                      asistencia.Presente=0;
                                    }
                                    else{
                                      asistencia.Presente=1;
                                    }
                                  
                                    setActividadFechaPorActualizar({...actividadFechaPorActualizar,['Asistencia']:asistencias});
                                  }}
                                >
                              </Form.Check.Input>
                              <span className="form-check-sign"></span>
                              {nombre}
                                </Form.Check.Label>
                            </Form.Check>

                             
                         
                            )
                            })
                    }
                              
                   </Col>
                              
                </Row>
                <MensajeAlerta mensajeTexto={respuestaActualizarActividadFecha.mensajeTexto} estado={respuestaActualizarActividadFecha.estado} />
                <Row>
                  <Col xs="6">
                  </Col>
                  <Col xs="6">
                    <br></br>
                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                        onClick={(e)=>{
                                       e.preventDefault();
                                       actualizarActividadFecha();
                        }}>
                        Actualizar Actividad
                      </Button>
                      <br></br>
                  </Col>
                  </Row>
                  <br></br>
                  <br></br>
                  

              </Card.Body>
            </Card>
            <br></br>
                    <br></br>
          </Col>
        </Row>
    </Container>
    </>
  );
}
export default EditarActividadFecha;
